import React from 'react'
import { CardType } from '@edge/spark/io-dashboards'
import type { BasicWidgetProps } from '../../types'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useOdsIfOfferListQuery } from '../../../../generated/graphql'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget/SingleNumberWidget'

const OdsOffersOverview: React.FC<BasicWidgetProps> = (props: BasicWidgetProps) => {
    const {
        config: {
            text = `IfOffer Beta`,
            /** If @param offset is passed in, it overrides the week modifier. */
        },
        widgetId,
        handleConfig,
        readonly,
    } = props

    const { data, loading } = useOdsIfOfferListQuery({
        variables: {
            searchString: 'status:offer',
            limit: 1,
            offset: 0,
        },
    })

    const results: any = data?.auction?.search?.vehicleCount

    return (
        <SingleNumberWidget
            cardType={CardType.VEHICLE}
            action={{
                text: 'View Vehicles',
                link: `/odsifoffers`,
            }}
            loading={loading}
            number={loading ? 0 : results}
            text={text}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default OdsOffersOverview
